import { CommitmentsTab } from "@/entities/commitments-tab-content";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const contactsCommitmentsRouteV2: RouteProps = {
  path: appRouterPaths.contacts.commitments,
  element: <CommitmentsTab />,
};
